import { render } from "./AddContractModel.vue?vue&type=template&id=39df05d8"
import script from "./AddContractModel.vue?vue&type=script&lang=js"
export * from "./AddContractModel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__